import { NgModule } from '@angular/core';
import { SimpleSorterPipe } from "libraries/pipes/simple-sorter/simple-sorter.pipe";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        SimpleSorterPipe
    ],
    declarations: [
        SimpleSorterPipe,
    ]
})
export class SimpleSorterModule {
}
